//RED

import redBulldozerWUrl from '../assets/icons/red/BulldozerW.svg';
import redBulldozerEUrl from '../assets/icons/red/BulldozerE.svg';

import redBusWUrl from '../assets/icons/red/BusW.svg';
import redBusEUrl from '../assets/icons/red/BusE.svg';

import redAljibeWUrl from '../assets/icons/red/CamiónAljibeW.svg';
import redAljibeEUrl from '../assets/icons/red/CamiónAljibeE.svg';

import redcamionCombustibleWUrl from '../assets/icons/red/CamiónLubricadorW.svg';
import redcamionCombustibleEUrl from '../assets/icons/red/CamiónLubricadorE.svg';

import redcamionPlumaWUrl from '../assets/icons/red/CamiónPlumaW.svg';
import redcamionPlumaEUrl from '../assets/icons/red/CamiónPlumaE.svg';

import redcargadorfrontalWUrl from '../assets/icons/red/CargadorFrontalW.svg';
import redcargadorfrontalEUrl from '../assets/icons/red/CargadorFrontalE.svg';

import redExcavadoraWUrl from '../assets/icons/red/ExcavadoraW.svg';
import redExcavadoraEUrl from '../assets/icons/red/ExcavadoraE.svg';

import redminibusWUrl from '../assets/icons/red/MinibusW.svg';
import redminibusEUrl from '../assets/icons/red/MinibusE.svg';

import redMotoniveladoraWUrl from '../assets/icons/red/MotoniveladoraW.svg';
import redMotoniveladoraEUrl from '../assets/icons/red/MotoniveladoraE.svg';

import redRetroExcavadoraWUrl from '../assets/icons/red/RetroexcavadoraW.svg';
import redRetroExcavadoraEUrl from '../assets/icons/red/RetroexcavadoraE.svg';

import redRodilloWUrl from '../assets/icons/red/RodilloW.svg';
import redRodilloEUrl from '../assets/icons/red/RodilloE.svg';

import redtractocamionWUrl from '../assets/icons/red/TRactocamiónW.svg';
import redtractocamionEUrl from '../assets/icons/red/TRactocamiónE.svg';

import redcamionetaWUrl from '../assets/icons/red/CamionetaW.svg';
import redcamionetaEUrl from '../assets/icons/red/CamionetaE.svg';

import redcamion34WUrl from '../assets/icons/red/Camioneta34W.svg';
import redcamion34EUrl from '../assets/icons/red/Camioneta34E.svg';

import redCamionDumperWUrl from '../assets/icons/red/CamiónDumperW.svg';
import redCamionDumperEUrl from '../assets/icons/red/CamiónDumperE.svg';

//PINK
import pinkBulldozerWUrl from '../assets/icons/pink/BulldozerW.svg';
import pinkBulldozerEUrl from '../assets/icons/pink/BulldozerE.svg';

import pinkBusWUrl from '../assets/icons/pink/BusW.svg';
import pinkBusEUrl from '../assets/icons/pink/BusE.svg';

import pinkAljibeWUrl from '../assets/icons/pink/CamiónAljibeW.svg';
import pinkAljibeEUrl from '../assets/icons/pink/CamiónAljibeE.svg';

import pinkcamionCombustibleWUrl from '../assets/icons/pink/CamiónLubricadorW.svg';
import pinkcamionCombustibleEUrl from '../assets/icons/pink/CamiónLubricadorE.svg';

import pinkcamionPlumaWUrl from '../assets/icons/pink/CamiónPlumaW.svg';
import pinkcamionPlumaEUrl from '../assets/icons/pink/CamiónPlumaE.svg';

import pinkcargadorfrontalWUrl from '../assets/icons/pink/CargadorFrontalW.svg';
import pinkcargadorfrontalEUrl from '../assets/icons/pink/CargadorFrontalE.svg';

import pinkExcavadoraWUrl from '../assets/icons/pink/ExcavadoraW.svg';
import pinkExcavadoraEUrl from '../assets/icons/pink/ExcavadoraE.svg';

import pinkminibusWUrl from '../assets/icons/pink/MinibusW.svg';
import pinkminibusEUrl from '../assets/icons/pink/MinibusE.svg';

import pinkMotoniveladoraWUrl from '../assets/icons/pink/MotoniveladoraW.svg';
import pinkMotoniveladoraEUrl from '../assets/icons/pink/MotoniveladoraE.svg';

import pinkRetroExcavadoraWUrl from '../assets/icons/pink/RetroexcavadoraW.svg';
import pinkRetroExcavadoraEUrl from '../assets/icons/pink/RetroexcavadoraE.svg';

import pinkRodilloWUrl from '../assets/icons/pink/RodilloW.svg';
import pinkRodilloEUrl from '../assets/icons/pink/RodilloE.svg';

import pinktractocamionWUrl from '../assets/icons/pink/TRactocamiónW.svg';
import pinktractocamionEUrl from '../assets/icons/pink/TRactocamiónE.svg';

import pinkcamionetaWUrl from '../assets/icons/pink/CamionetaW.svg';
import pinkcamionetaEUrl from '../assets/icons/pink/CamionetaE.svg';

import pinkcamion34WUrl from '../assets/icons/pink/Camioneta34W.svg';
import pinkcamion34EUrl from '../assets/icons/pink/Camioneta34E.svg';

import pinkCamionDumperWUrl from '../assets/icons/pink/CamiónDumperW.svg';
import pinkCamionDumperEUrl from '../assets/icons/pink/CamiónDumperE.svg';

//BLUE

import blueBulldozerWUrl from '../assets/icons/blue/BulldozerW.svg';
import blueBulldozerEUrl from '../assets/icons/blue/BulldozerE.svg';

import blueBusWUrl from '../assets/icons/blue/BusW.svg';
import blueBusEUrl from '../assets/icons/blue/BusE.svg';

import bluecamionAljibeWUrl from '../assets/icons/blue/CamiónAljibeW.svg';
import bluecamionAljibeEUrl from '../assets/icons/blue/CamiónAljibeE.svg';

import bluecamionCombustibleWUrl from '../assets/icons/blue/CamiónLubricadorW.svg';
import bluecamionCombustibleEUrl from '../assets/icons/blue/CamiónLubricadorE.svg';

import bluecamionPlumaWUrl from '../assets/icons/blue/CamiónPlumaW.svg';
import bluecamionPlumaEUrl from '../assets/icons/blue/CamiónPlumaE.svg';

import bluecargadorfrontalWUrl from '../assets/icons/blue/CargadorFrontalW.svg';
import bluecargadorfrontalEUrl from '../assets/icons/blue/CargadorFrontalE.svg';

import blueExcavadoraWUrl from '../assets/icons/blue/ExcavadoraW.svg';
import blueExcavadoraEUrl from '../assets/icons/blue/ExcavadoraE.svg';

import blueminibusWUrl from '../assets/icons/blue/MinibusW.svg';
import blueminibusEUrl from '../assets/icons/blue/MinibusE.svg';

import blueMotoniveladoraWUrl from '../assets/icons/blue/MotoniveladoraW.svg';
import blueMotoniveladoraEUrl from '../assets/icons/blue/MotoniveladoraE.svg';

import blueRetroExcavadoraWUrl from '../assets/icons/blue/RetroexcavadoraW.svg';
import blueRetroExcavadoraEUrl from '../assets/icons/blue/RetroexcavadoraE.svg';

import blueRodilloWUrl from '../assets/icons/blue/RodilloW.svg';
import blueRodilloEUrl from '../assets/icons/blue/RodilloE.svg';

import bluetractocamionWUrl from '../assets/icons/blue/TRactocamiónW.svg';
import bluetractocamionEUrl from '../assets/icons/blue/TRactocamiónE.svg';

import bluecamionetaWUrl from '../assets/icons/blue/CamionetaW.svg';
import bluecamionetaEUrl from '../assets/icons/blue/CamionetaE.svg';

import bluecamion34WUrl from '../assets/icons/blue/Camioneta34W.svg';
import bluecamion34EUrl from '../assets/icons/blue/Camioneta34E.svg';

import blueCamionDumperWUrl from '../assets/icons/blue/CamiónDumperW.svg';
import blueCamionDumperEUrl from '../assets/icons/blue/CamiónDumperE.svg';

//WHITE
import whiteBulldozerEUrl from '../assets/icons/white/BulldozerE.svg';
import whiteBusEUrl from '../assets/icons/white/BusE.svg';
import whitecamionAljibeEUrl from '../assets/icons/white/CamiónAljibeE.svg';
import whitecamionCombustibleEUrl from '../assets/icons/white/CamiónLubricadorE.svg';
import whitecamionPlumaEUrl from '../assets/icons/white/CamiónPlumaE.svg';
import whitecargadorfrontalEUrl from '../assets/icons/white/CargadorFrontalE.svg';
import whiteExcavadoraEUrl from '../assets/icons/white/ExcavadoraE.svg';
import whiteminibusEUrl from '../assets/icons/white/MinibusE.svg';
import whiteMotoniveladoraEUrl from '../assets/icons/white/MotoniveladoraE.svg';
import whiteRetroExcavadoraEUrl from '../assets/icons/white/RetroexcavadoraE.svg';
import whiteRodilloEUrl from '../assets/icons/white/RodilloE.svg';
import whitetractocamionEUrl from '../assets/icons/white/TRactocamiónE.svg';
import whitecamionTolvaUrl from '../assets/icons/white/tolva.svg';
import whitecamionetaEUrl from '../assets/icons/white/CamionetaE.svg';
import whitecamion34EUrl from '../assets/icons/white/Camioneta34E.svg';
import whiteCamionDumperEUrl from '../assets/icons/white/CamiónDumperE.svg';

//TOLVAS
import blueTolva45Url from '../assets/icons/blue/tolvas/45.svg';
import blueTolva135Url from '../assets/icons/blue/tolvas/135.svg';
import blueTolva225Url from '../assets/icons/blue/tolvas/225.svg';
import blueTolva315Url from '../assets/icons/blue/tolvas/315.svg';

import pinkTolva45Url from '../assets/icons/pink/tolvas/45.svg';
import pinkTolva135Url from '../assets/icons/pink/tolvas/135.svg';
import pinkTolva225Url from '../assets/icons/pink/tolvas/225.svg';
import pinkTolva315Url from '../assets/icons/pink/tolvas/315.svg';

import redTolva45Url from '../assets/icons/red/tolvas/45.svg';
import redTolva135Url from '../assets/icons/red/tolvas/135.svg';
import redTolva225Url from '../assets/icons/red/tolvas/225.svg';
import redTolva315Url from '../assets/icons/red/tolvas/315.svg';

export const router = {
  pinkbulldozerW: pinkBulldozerWUrl,
  pinkbulldozerE: pinkBulldozerEUrl,
  pinkbusW: pinkBusWUrl,
  pinkbusE: pinkBusEUrl,
  pinkcamionCombustibleW: pinkcamionCombustibleWUrl,
  pinkcamionCombustibleE: pinkcamionCombustibleEUrl,
  pinkcamionPlumaW: pinkcamionPlumaWUrl,
  pinkcamionPlumaE: pinkcamionPlumaEUrl,
  pinkcargadorFrontalW: pinkcargadorfrontalWUrl,
  pinkcargadorFrontalE: pinkcargadorfrontalEUrl,
  pinkcamionAljibeW: pinkAljibeWUrl,
  pinkcamionAljibeE: pinkAljibeEUrl,
  pinkexcavadoraW: pinkExcavadoraWUrl,
  pinkexcavadoraE: pinkExcavadoraEUrl,

  pinkminibusW: pinkminibusWUrl,
  pinkminibusE: pinkminibusEUrl,

  pinkmotoniveladoraW: pinkMotoniveladoraWUrl,
  pinkmotoniveladoraE: pinkMotoniveladoraEUrl,

  pinkretroexcavadoraW: pinkRetroExcavadoraWUrl,
  pinkretroexcavadoraE: pinkRetroExcavadoraEUrl,

  pinkrodilloW: pinkRodilloWUrl,
  pinkrodilloE: pinkRodilloEUrl,

  pinktractocamionW: pinktractocamionWUrl,
  pinktractocamionE: pinktractocamionEUrl,

  pinkcamionCombustible: pinkAljibeEUrl,

  pinkcamionetaW: pinkcamionetaWUrl,
  pinkcamionetaE: pinkcamionetaEUrl,

  pinkcamion34W: pinkcamion34WUrl,
  pinkcamion34E: pinkcamion34EUrl,

  pinkcamionDumperW: pinkCamionDumperWUrl,
  pinkcamionDumperE: pinkCamionDumperEUrl,

  //RED
  redbulldozerW: redBulldozerWUrl,
  redbulldozerE: redBulldozerEUrl,
  redbusW: redBusWUrl,
  redbusE: redBusEUrl,
  redcamionCombustibleW: redcamionCombustibleWUrl,
  redcamionCombustibleE: redcamionCombustibleEUrl,
  redcamionLubricadorW: redcamionCombustibleWUrl,
  redcamionLubricadorE: redcamionCombustibleEUrl,
  redcamionPlumaW: redcamionPlumaWUrl,
  redcamionPlumaE: redcamionPlumaEUrl,
  redcargadorFrontalW: redcargadorfrontalWUrl,
  redcargadorFrontalE: redcargadorfrontalEUrl,
  redcamionAljibeW: redAljibeWUrl,
  redcamionAljibeE: redAljibeEUrl,
  redexcavadoraW: redExcavadoraWUrl,
  redexcavadoraE: redExcavadoraEUrl,

  redminibusW: redminibusWUrl,
  redminibusE: redminibusEUrl,

  redmotoniveladoraW: redMotoniveladoraWUrl,
  redmotoniveladoraE: redMotoniveladoraEUrl,

  redretroexcavadoraW: redRetroExcavadoraWUrl,
  redretroexcavadoraE: redRetroExcavadoraEUrl,

  redrodilloW: redRodilloWUrl,
  redrodilloE: redRodilloEUrl,

  redtractoCamionW: redtractocamionWUrl,
  redtractoCamionE: redtractocamionEUrl,

  redcamionCombustible: redAljibeEUrl,

  redcamionetaW: redcamionetaWUrl,
  redcamionetaE: redcamionetaEUrl,

  redcamion34W: redcamion34WUrl,
  redcamion34E: redcamion34EUrl,

  redcamionDumperW: redCamionDumperWUrl,
  redcamionDumperE: redCamionDumperEUrl,

  //Blue
  bluebulldozerW: blueBulldozerWUrl,
  bluebulldozerE: blueBulldozerEUrl,
  bluebusW: blueBusWUrl,
  bluebusE: blueBusEUrl,
  bluecamionCombustibleW: bluecamionCombustibleWUrl,
  bluecamionCombustibleE: bluecamionCombustibleEUrl,
  bluecamionPlumaW: bluecamionPlumaWUrl,
  bluecamionPlumaE: bluecamionPlumaEUrl,
  bluecargadorFrontalW: bluecargadorfrontalWUrl,
  bluecargadorFrontalE: bluecargadorfrontalEUrl,
  bluecamionAljibeW: bluecamionAljibeWUrl,
  bluecamionAljibeE: bluecamionAljibeEUrl,
  blueexcavadoraW: blueExcavadoraWUrl,
  blueexcavadoraE: blueExcavadoraEUrl,

  blueminibusW: blueminibusWUrl,
  blueminibusE: blueminibusEUrl,

  bluemotoniveladoraW: blueMotoniveladoraWUrl,
  bluemotoniveladoraE: blueMotoniveladoraEUrl,

  blueretroexcavadoraW: blueRetroExcavadoraWUrl,
  blueretroexcavadoraE: blueRetroExcavadoraEUrl,

  bluerodilloW: blueRodilloWUrl,
  bluerodilloE: blueRodilloEUrl,

  bluetractocamionW: bluetractocamionWUrl,
  bluetractocamionE: bluetractocamionEUrl,

  bluecamionetaW: bluecamionetaWUrl,
  bluecamionetaE: bluecamionetaEUrl,

  bluecamion34W: bluecamion34WUrl,
  bluecamion34E: bluecamion34EUrl,

  bluecamionDumperW: blueCamionDumperWUrl,
  bluecamionDumperE: blueCamionDumperEUrl,

  //TOLVAS

  bluecamiontolva45: blueTolva45Url,
  bluecamiontolva135: blueTolva135Url,
  bluecamiontolva225: blueTolva225Url,
  bluecamiontolva315: blueTolva315Url,

  pinkcamiontolva45: pinkTolva45Url,
  pinkcamiontolva135: pinkTolva135Url,
  pinkcamiontolva225: pinkTolva225Url,
  pinkcamiontolva315: pinkTolva315Url,

  redcamiontolva45: redTolva45Url,
  redcamiontolva135: redTolva135Url,
  redcamiontolva225: redTolva225Url,
  redcamiontolva315: redTolva315Url,
};

export const basemapTilesSource = {
  OSM: 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
  Satellite:
    'https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.webp?sku=101tPSMaGVHpz&access_token=pk.eyJ1Ijoiam9zZS12YWxsZWpvczE0MTIiLCJhIjoiY205YWZsbXA4MDU0ODJscHZuMHQzNXk2NCJ9.TEILB_hjIjyUoJSCfyLdoQ',
};

export const getPopupHtml = truckProperties => {
  let tableHtml = `<table class="g100" border="1" style="border-collapse: collapse; padding: 3px; ">
        <thead>
            <tr ">
                <th style="font-weight: bold; border-bottom: 3px solid orange; width: 100px;">${
                  truckProperties.type
                }</th>
                <th style="width: 150px; "></th>
            </tr>
        </thead>
        <tbody>`;

  const fixedValues = [
    { label: 'Velocidad', key: 'velocidad' },
    { label: 'Tiempo Actual', key: 'currTime' },
    // { label: "Longitud", key: "row3" },
    // { label: "Latitud", key: "row4" },
    { label: 'ID', key: 'device_id' },
    { label: 'Patente', key: 'truckPatent' },
    { label: 'Grupo', key: 'group' },
    { label: 'Operador', key: 'curr_operador' },
    { label: 'iButton', key: 'ib' },
    { label: 'Diff (mins)', key: 'timeDiffMinutes' },
    { label: 'Category', key: 'time_category' },
    { label: 'Rumbo', key: 'head' },
  ];

  fixedValues.forEach((fixedValue, index) => {
    let value = truckProperties[fixedValue.key];
    if (fixedValue.key === 'currTime' && value) {
      value = new Date(value).toLocaleString();
    }
    tableHtml += `<tr style="border-bottom: 1px solid lightgrey;">
            <td>${fixedValue.label}</td>
            <td>${value !== undefined ? value : ''}</td>
        </tr>`;
  });

  tableHtml += `</tbody>
    </table>`;

  return tableHtml;
};

export const legendRouter = [
  {
    label: 'Bulldozer',
    src: whiteBulldozerEUrl,
  },
  {
    label: 'Camión Aljibe',
    src: whitecamionAljibeEUrl,
  },
  {
    label: 'Camión Combustible',
    src: whitecamionCombustibleEUrl,
  },
  {
    label: 'Camión Lubricador',
    src: whitecamionCombustibleEUrl,
  },
  {
    label: 'Camión Pluma',
    src: whitecamionPlumaEUrl,
  },
  {
    label: 'Camión Tolva',
    src: whitecamionTolvaUrl,
  },
  {
    label: 'Cargador Frontal',
    src: whitecargadorfrontalEUrl,
  },
  {
    label: 'Excavadora',
    src: whiteExcavadoraEUrl,
  },
  {
    label: 'MiniBus',
    src: whiteminibusEUrl,
  },
  {
    label: 'Motoniveladora',
    src: whiteMotoniveladoraEUrl,
  },
  {
    label: 'Retroexcavadora',
    src: whiteRetroExcavadoraEUrl,
  },
  {
    label: 'Rodillo',
    src: whiteRodilloEUrl,
  },
  {
    label: 'Bus',
    src: whiteBusEUrl,
  },
  {
    label: 'Tracto Camión',
    src: whitetractocamionEUrl,
  },
  {
    label: 'Camión Dumper',
    src: whiteCamionDumperEUrl,
  },
  {
    label: 'Camioneta',
    src: whitecamionetaEUrl,
  },
  {
    label: 'Camión 3 4',
    src: whitecamion34EUrl,
  },
];
